module.exports = __webpack_public_path__ + "static/media/lito_skew.9c17ad5b.gif";